export default __webpack_public_path__ + "static/media/GraftCafe-2.4bef1990.jpg";